import React, { Component } from 'react';
import pkg from '../../../../../package.json';

const { version } = pkg;

class Version extends Component {

    // state = {
    //     apiVersion: '1.028',
    // }

    // componentWillMount = () => {
    //     // this.setState({apiVersion: this.props.configResp.apiVersion});
    // }

    render = () => (
        <span>
            {/*{version} (API: {this.state.apiVersion})*/}
            {version} (API: {process.env.REACT_APP_API_VER})
        </span>
    );

}

Version.displayName = 'Version';

export default Version;
